import script from "./MoleculeCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCard.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCard.vue?vue&type=style&index=0&id=5330aea4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5330aea4"]])

export default __exports__